import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logOutAction, selectUserId } from "../../redux/authSlice";
import history from "../../utils/history";
import urls from "../../global/constants/UrlConstants";
import { clearNotificationToken } from "../../utils/PushNotification/pushNotificationService";

const Timer = (props: any) => {
  const { initMinute = 0, initSeconds = 10 } = props;
  const [minutes, setMinutes] = React.useState(initMinute);
  const [seconds, setSeconds] = React.useState(initSeconds);
  const dispatch = useDispatch();
  const userId = useSelector(selectUserId);

  const logout = async () => {
    try {
      const uid = String(userId || "").trim();
      if (uid) {
        await clearNotificationToken({ userId: uid, source: "web" });
      }
    } catch {
      // ignore
    }
    dispatch(logOutAction());
    history.push(urls.loginViewPath);
  };

  React.useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          // Trigger logout when timer hits 0
          logout();
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [minutes, seconds]); // Add minutes and seconds as dependencies to useEffect

  return (
    <h1 style={{ fontSize: "20px" }}>
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </h1>
  );
};

export default Timer;
